import helpers from '@/services/helpers'

export default {
    install: (app , options) => {
        app.config.globalProperties.$helpers = helpers
    }
}  

